import {Component, Input} from '@angular/core';
import {InfoPageHeaderComponent} from '../info-page-header/info-page-header.component';
import {DocumentViewerComponent} from '../document-viewer/document-viewer.component';

@Component({
  selector: 'app-document-viewer-page',
  standalone: true,
  templateUrl: './document-viewer-page.component.html',
  styleUrls: ['./document-viewer-page.component.scss'],
  imports: [InfoPageHeaderComponent, DocumentViewerComponent]
})
export class DocumentViewerPageComponent {

  @Input() label!: string;
  @Input() url!: string;
  @Input() navigateTo?: string;

  constructor() {
  }
}
